import { Attribute } from '@df/catalog/attribute/attribute';
import { Model } from '@df/catalog/model';
import { Filter, IFilterConfig } from '@df/catalog-ui/listing/filter/filter';

/**
 * Attribute filter abstract class
 */
export abstract class FilterAttribute<T extends Model, S, C extends IFilterConfig<string> = IFilterConfig<string>> extends Filter<
    T,
    S,
    string,
    C
> {
    /**
     * Attribute getter
     */
    public get attribute(): Attribute {
        return this.app.resources.attribute.get(this.id);
    }
}
